import { render, staticRenderFns } from "./SocialExpandable.vue?vue&type=template&id=193a209f&scoped=true"
import script from "./SocialExpandable.vue?vue&type=script&lang=js"
export * from "./SocialExpandable.vue?vue&type=script&lang=js"
import style0 from "./SocialExpandable.vue?vue&type=style&index=0&id=193a209f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a209f",
  null
  
)

export default component.exports